import { render } from "./StatusDetailVx.vue?vue&type=template&id=c73dfe48"
import script from "./StatusDetailVx.vue?vue&type=script&lang=js"
export * from "./StatusDetailVx.vue?vue&type=script&lang=js"

import "./StatusDetailVx.vue?vue&type=style&index=0&id=c73dfe48&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__